import { isBrowser } from './browser.js';

const GSAP_URL = 'https://cdn.jsdelivr.net/npm/gsap@3/dist/gsap.min.js';
const SCROLL_TRIGGER_URL =
  'https://cdn.jsdelivr.net/npm/gsap@3/dist/ScrollTrigger.min.js';

const loadScript = (url, check) => {
  if (!isBrowser) {
    return Promise.resolve(false);
  }

  if (check()) {
    return Promise.resolve(true);
  }

  const existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return new Promise((resolve) => {
      existingScript.addEventListener('load', () => resolve(true), {
        once: true,
      });
      existingScript.addEventListener('error', () => resolve(false), {
        once: true,
      });
    });
  }

  return new Promise((resolve) => {
    const script = document.createElement('script');

    script.src = url;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.head.appendChild(script);
  });
};

export const loadGsap = async () => {
  const isLoaded = await loadScript(GSAP_URL, () => Boolean(window.gsap));

  return isLoaded ? window.gsap : null;
};

export const loadScrollTrigger = async (gsap) => {
  if (!gsap) {
    return null;
  }

  if (window.ScrollTrigger) {
    gsap.registerPlugin(window.ScrollTrigger);
    return window.ScrollTrigger;
  }

  const isLoaded = await loadScript(
    SCROLL_TRIGGER_URL,
    () => Boolean(window.ScrollTrigger)
  );

  if (!isLoaded || !window.ScrollTrigger) {
    return null;
  }

  gsap.registerPlugin(window.ScrollTrigger);
  return window.ScrollTrigger;
};
